export default "__VITE_ASSET__wKyddbEu__"